import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import Amplify from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import config from './config'
import { Provider } from 'react-redux'
import store from './redux/store'
import { BrowserRouter as Router } from 'react-router-dom'
import ScrollToTop from 'components/scrollToTop'
import {
  createTheme,
  CssBaseline,
  ThemeProvider,
  Theme,
  StyledEngineProvider,
  adaptV4Theme,
} from '@mui/material';
import ErrorBoundary from 'components/errorBoundary'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { StylesProvider, createGenerateClassName } from '@mui/styles'
import { sendToGoogleAnalytics } from './reportWebVitals'
import { getCLS, getFID, getLCP, getTTFB, getFCP } from 'web-vitals'


declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

// Use a distinct prefix for @mui/styles (v5) JSS class names to prevent
// collisions with @material-ui/core (v4) JSS class names in production builds.
// Both systems use "jss" as their default production prefix, causing class name
// overlap that breaks layout on pages where v4 DatePicker is rendered.
const generateClassName = createGenerateClassName({ productionPrefix: 'muiv5' })


Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: 'products',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          }
        },
      },
    ],
  },
})

const theme = createTheme(adaptV4Theme({
  palette: {
    primary: { main: '#464b69' },
    secondary: { main: '#ff9fa5' },
  },
}))

if (typeof window !== 'undefined') {
  (window as any).store = store
}

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <StyledEngineProvider injectFirst>
          <StylesProvider generateClassName={generateClassName}>
            <ThemeProvider theme={theme}>
              <Router>
                <ScrollToTop />
                <App />
                <CssBaseline />
              </Router>
            </ThemeProvider>
          </StylesProvider>
        </StyledEngineProvider>
      </MuiPickersUtilsProvider>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
)


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()

getCLS(sendToGoogleAnalytics)
getFID(sendToGoogleAnalytics)
getLCP(sendToGoogleAnalytics)
getTTFB(sendToGoogleAnalytics)
getFCP(sendToGoogleAnalytics)
